import { Component, Input, SimpleChanges } from "@angular/core";
import { BaseComponent } from "../..";
import { ParamType } from "../shared";
import { ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: 'visual-object-icon',
  templateUrl: './visualObjectIconComponent.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisualObjectIconComponent extends BaseComponent {

  @Input()
  public size: number = 40;

  @Input()
  public iconSize: number = 16;

  /** Image set for svg. Like "primary", "primary-dark" etc. */
  @Input()
  imageSet: string = 'primary';

  @Input()
  backgroundImage: string;

  @Input()
  public paramType: ParamType;

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }
}
